class RelatedArticlesWrapper extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.addEventListener("tab-component:tab-selected", (e) => {
        this.querySelectorAll("[data-show-for]").forEach((el) => {
          el.style.display =
            el.dataset.showFor === e.detail.tab.id ? null : "none";
        });
      });
    }
  
    disconnectedCallback() {}
  }
  
  if (!customElements.get("related-articles-wrapper")) {
    customElements.define("related-articles-wrapper", RelatedArticlesWrapper);
  }